import type { CostPerLeadQuery } from "@/api/buyerReports";

/**
 * Query keys for the buyer reports surface (WS-B4).
 *
 * <p>The board is keyed per team, and the caller's own board under the same
 * `board` segment, so ONE `buyerReportKeys.all` invalidation after a
 * reassignment reaches both — the quick-pick on a stale row moves a lead off
 * one card and onto another, and both views of that team must learn it.</p>
 */
export const buyerReportKeys = {
  all: ["buyer-reports"] as const,
  boards: () => [...buyerReportKeys.all, "board"] as const,
  board: (teamId: string) => [...buyerReportKeys.boards(), teamId] as const,
  myBoard: () => [...buyerReportKeys.boards(), "me"] as const,
  costPerLead: (query: CostPerLeadQuery) =>
    [...buyerReportKeys.all, "cost-per-lead", query] as const,
};
